import ModelInterface from 'src/models/ModelInterface'
import {RawNotify} from '@/types/entity/RawNotify'

class Notify extends ModelInterface<RawNotify> {

  constructor (data: RawNotify) {
    super(data)
  }

  public getId (): string {
    return this.data.notify_id
  }

  public getUserId (): string {
    return this.data.user_id
  }

  public getType (): string {
    return this.data.type
  }

  public getBody () {
    return this.data.body
  }

  public getTs (): number {
    return this.data.ts || 0
  }

  public getReadIds () {
    return this.data.read_ids
  }

  public getIsRead () {
    return this.data.is_read
  }

  public setRead () {
    if (!this.data.is_read) {
      this.data.is_read = true
    }
  }

  get ts () {
    return this.getTs();
  }
}

export default Notify